export default __webpack_public_path__ + "static/media/11d.d8612df8.svg";